// Redirect old tag-filtered collection URLs to new collection pages
(function () {
  // prevent double-firing if this file gets included twice
  if (window.__smmRedirected) return;
  window.__smmRedirected = true;

  try {
    var path = (location.pathname || "").toLowerCase();
    var search = (location.search || "");

    // Try path pattern first: /collections/<collection>/<tags>
    var m = path.match(/^\/collections\/([^\/?#]+)\/([^\/?#]+)/);
    var collection = "", tagSegment = "";

    if (m) {
      collection = m[1];                       // e.g., "neodymium"
      tagSegment = decodeURIComponent(m[2] || "");
    } else {
      // Fallback: /collections/<collection>?constraint=<tags>
      var m2 = path.match(/^\/collections\/([^\/?#]+)/);
      if (!m2) return;
      collection = m2[1];
      var params = new URLSearchParams(search);
      if (!params.has("constraint")) return;   // nothing to do
      tagSegment = decodeURIComponent(params.get("constraint") || "");
    }

    // Normalize tags (support multi-tag like cubes+black)
    function slug(s){
      return String(s)
        .toLowerCase()
        .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .replace(/&/g, '-and-')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }
    var tags = tagSegment.split('+').map(slug).filter(Boolean);
    if (!tags.length) return;

    // YOUR mapping (keep these destinations as you have them)
    var map = {
      "neodymium": {
        "cubes": "/collections/neo-cubes",
        "cube":  "/collections/neo-cubes",
        "discs": "/collections/disc-magnets",
        "disc":  "/collections/disc-magnets",
        "rings": "/collections/ring-magnets",
        "ring":  "/collections/ring-magnets",
        "rectangles": "/collections/rectangle-magnets",
        "rectangle":  "/collections/rectangle-magnets",
        "cylinders": "/collections/neo-cylinders",
        "cylinder":  "/collections/neo-cylinders",
        "arcs": "/collections/neo-arcs",
        "arc":  "/collections/neo-arcs",
        "spheres": "/collections/neo-spheres",
        "sphere":  "/collections/neo-spheres",
        "cones": "/collections/neo-cones",
        "cone":  "/collections/neo-cones",
        "tubes": "/collections/neo-tubes",
        "tube":  "/collections/neo-tubes",
        "squares": "/collections/neo-squares",
        "square":  "/collections/neo-squares",
        "pyramids": "/collections/neo-pyramids",
        "pyramid":  "/collections/neo-pyramids"
      },
      "samarium-cobalt": {
        "discs": "/collections/disc-magnets",
        "disc":  "/collections/disc-magnets",
        "rings": "/collections/rings-magnets",
        "ring":  "/collections/rings-magnets",
        "rectangles": "/collections/rectangle-magnets",
        "rectangle":  "/collections/rectangle-magnets"
      }
    };

    var mapForCollection = map[collection];
    if (!mapForCollection) return;

    var dest = "";
    for (var i = 0; i < tags.length; i++) {
      var t = tags[i];
      if (mapForCollection[t]) { dest = mapForCollection[t]; break; }
    }
    if (!dest) return;

    // keep UTMs etc.
    var url = new URL(dest, location.origin);
    if (search) url.search = search;
    location.replace(url.toString());
  } catch (e) { /* silent */ }
})();

/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// === 1) Core initializer (safe to call multiple times) ===
// function initializeMOQNotes(root = document) {
//   const qtyInputs = root.querySelectorAll([
//       '.quantity-selector__value[inputmode="numeric"]',
//       'input.quantity__input',
//       'input[type="number"][name*="quantity"]',
//       'input[name="updates[]"]'
//   ].join(','));

//   qtyInputs.forEach((input) => {
//       if (input.dataset.moqInitialized === '1') return;
//       input.dataset.moqInitialized = '1';

//       const wrapper =
//           input.closest('.quantity-selector') ||
//           input.closest('.quantity') ||
//           input.parentElement;
//       if (!wrapper) return;

//       // === Detect context (product page, cart, or mini cart) ===
//       const isMiniCart = wrapper.closest('.mini-cart, [data-cart-drawer]');
//       const isCartPage = wrapper.closest('.template-cart');
//       const isProductPage = document.body.classList.contains('template-product');

//       // === Determine MOQ ===
//       const moq =
//           parseInt(input.getAttribute('min')) ||
//           parseInt(input.dataset.moq) ||
//           parseInt(input.getAttribute('data-min')) ||
//           1;

//       // Ensure the input's 'min' attribute is correctly set to MOQ
//       input.setAttribute('min', moq);

//       const container = wrapper.parentElement || wrapper;

//       // === Determine placement container ===
//       let moqSlot;
//       if (isProductPage) {
//           const contentSlot = container.closest('.product-form__info-item--quantity .product-form__info-content');
//           if (contentSlot) {
//               moqSlot = contentSlot.querySelector('.moq-slot--product');
//               if (!moqSlot) {
//                   moqSlot = document.createElement('div');
//                   moqSlot.className = 'moq-slot moq-slot--product';
//                   contentSlot.appendChild(moqSlot);
//               }
//           }

//           if (!moqSlot) {
//               moqSlot = container.querySelector('.moq-slot--product');
//               if (!moqSlot) {
//                   moqSlot = document.createElement('div');
//                   moqSlot.className = 'moq-slot moq-slot--product';
//                   container.appendChild(moqSlot);
//               }
//           }
//       } else if (isMiniCart) {
//           moqSlot = container.querySelector('.moq-slot--mini');
//           if (!moqSlot) {
//               moqSlot = document.createElement('div');
//               moqSlot.className = 'moq-slot moq-slot--mini';
//               const removeLink = container.querySelector('.mini-cart__quantity-remove');
//               container.insertBefore(moqSlot, removeLink || null);
//           }
//       } else if (isCartPage) {
//           moqSlot = container.querySelector('.moq-slot--cart');
//           if (!moqSlot) {
//               moqSlot = document.createElement('div');
//               moqSlot.className = 'moq-slot moq-slot--cart';
//               const removeLink = container.querySelector('.line-item__quantity-remove');
//               container.insertBefore(moqSlot, removeLink || null);
//           }
//       } else {
//           moqSlot = container.querySelector('.moq-slot');
//           if (!moqSlot) {
//               moqSlot = document.createElement('div');
//               moqSlot.className = 'moq-slot';
//               container.appendChild(moqSlot);
//           }
//       }

//       // Move any existing notes/warnings into slot to avoid duplicates
//       Array.from(container.querySelectorAll('.moq-note')).forEach((note) => {
//           if (note.parentElement !== moqSlot) {
//               moqSlot.appendChild(note);
//           }
//       });

//       Array.from(container.querySelectorAll('.quantity-warning')).forEach((warn) => {
//           if (warn.parentElement !== moqSlot) {
//               moqSlot.appendChild(warn);
//           }
//       });

//       // === MOQ note (always visible) ===
//       let moqNote = moqSlot.querySelector('.moq-note');
//       if (!moqNote) {
//           moqNote = document.createElement('div');
//           moqNote.className = 'moq-note';
//           moqSlot.appendChild(moqNote);
//       }
//       moqNote.textContent = `Minimum Order Quantity: ${moq}`;

//       // === Reuse or create the yellow warning div (prevent duplicates) ===
//       let warning = moqSlot.querySelector('.quantity-warning');
//       if (!warning) {
//           warning = document.createElement('div');
//           warning.className = 'quantity-warning';
//           moqSlot.appendChild(warning);
//       }

//       warning.classList.remove('warning-below', 'warning-right', 'warning-inline', 'warning-mini', 'warning-cart', 'warning-product');
//       if (isMiniCart) {
//           warning.classList.add('warning-mini');
//       } else if (isCartPage) {
//           warning.classList.add('warning-cart');
//       } else if (isProductPage) {
//           warning.classList.add('warning-product');
//       }

//       // === Validation logic ===
//       function showWarning(pin = false) {
//           let icon = warning.querySelector('.quantity-warning__icon');
//           if (!icon) {
//               icon = document.createElement('span');
//               icon.className = 'quantity-warning__icon';
//               icon.setAttribute('aria-hidden', 'true');
//               icon.textContent = '⚠️';
//               warning.insertBefore(icon, warning.firstChild);
//           }

//           let message = warning.querySelector('.quantity-warning__text');
//           if (!message) {
//               message = document.createElement('span');
//               message.className = 'quantity-warning__text';
//               warning.appendChild(message);
//           }

//           message.innerHTML = `Minimum order quantity is <strong>${moq}</strong>. Please enter ${moq} or higher to proceed.`;
//           warning.style.display = 'flex';
//           warning.classList.add('visible');
//           moqSlot.classList.add('moq-slot--active');

//           if (pin) {
//               warning.dataset.pinned = '1';
//           } else {
//               delete warning.dataset.pinned;
//           }
//       }

//       function hideWarning(force = false) {
//           if (warning.dataset.pinned === '1' && !force) {
//               return;
//           }

//           warning.style.display = 'none';
//           warning.classList.remove('visible');
//           warning.innerHTML = '';
//           delete warning.dataset.pinned;
//           moqSlot.classList.remove('moq-slot--active');
//       }

//       function validateQty() {
//           const value = parseInt(input.value || 0);
//           if (isNaN(value)) {
//               // If input is truly empty/invalid, force it to MOQ and show warning
//               input.value = moq; 
//               input.setAttribute('data-current-value', moq);
//               showWarning(true); // Pin the warning
//               return;
//           }

//           input.setAttribute('data-current-value', value);
//           if (value < moq) {
//               showWarning();
//           } else {
//               hideWarning(true);
//           }
//       }

//       // === Sync minus button to current input (let theme.js handle the AJAX) ===
//       const decreaseButtons = wrapper.querySelectorAll('[data-action="decrease-quantity"], [data-action="decrease-picker-quantity"], [data-action="decrease-cart-quantity"], [data-action="minus"]');
//       if (decreaseButtons.length) {
//           decreaseButtons.forEach((btn) => {
//               btn.addEventListener('click', (e) => {
//                   let current = parseInt(input.value);
//                   if (isNaN(current)) current = moq; // If input is empty, start from MOQ for decrement

//                   let next = current - 1;
//                   if (next < moq) next = moq; // Don't allow decrement below MOQ visually/programmatically

//                   // Update input value
//                   input.value = next;
//                   input.setAttribute('data-current-value', next);
//                   input.dispatchEvent(new Event('input', { bubbles: true }));
//                   input.dispatchEvent(new Event('change', { bubbles: true }));

//                   // Update the data-quantity attribute for the theme's AJAX call
//                   e.currentTarget.setAttribute('data-quantity', next);

//                   if (next < moq) {
//                       showWarning(true); // Pin warning if we're at MOQ but couldn't go lower
//                       if (!warning.classList.contains('alert-shown')) {
//                           warning.classList.add('alert-shown');
//                           setTimeout(() => { warning.classList.remove('alert-shown'); }, 10000);
//                       }
//                   } else {
//                       hideWarning(true);
//                   }
//                   // Do not stop propagation: allow theme Cart._updateQuantity to run
//               }, true); // Use capture phase
//           });
//       }

//       // === Sync plus button to current input (let theme.js handle the AJAX) ===
//       const increaseButtons = wrapper.querySelectorAll('[data-action="increase-quantity"], [data-action="increase-picker-quantity"], [data-action="increase-cart-quantity"], [data-action="plus"]');
//       if (increaseButtons.length) {
//           increaseButtons.forEach((btn) => {
//               btn.addEventListener('click', (e) => {
//                   let current = parseInt(input.value);
//                   let next;

//                   // If empty or below MOQ, clicking plus should jump to MOQ
//                   if (isNaN(current) || current < moq) {
//                       next = moq;
//                   } else {
//                       next = current + 1;
//                   }

//                   // Update input value immediately
//                   input.value = next;
//                   input.setAttribute('data-current-value', next);
//                   input.dispatchEvent(new Event('input', { bubbles: true }));
//                   input.dispatchEvent(new Event('change', { bubbles: true }));

//                   // Update the data-quantity attribute that the theme's AJAX handler might also read
//                   e.currentTarget.setAttribute('data-quantity', next);

//                   hideWarning(true); // Hide warning as we're now at or above MOQ
//                   // Do not stop propagation: allow theme Cart._updateQuantity to run
//               }, true); // Use capture phase
//           });
//       }

//       // === Watch for changes (validation + keep buttons in sync) ===
//       input.addEventListener('input', () => { validateQty(); syncButtonAttrs(); });
//       const syncButtonAttrs = () => {
//           const current = parseInt(input.value);
//           const plusBtn = wrapper.querySelector('[data-action="increase-quantity"], [data-action="increase-picker-quantity"], [data-action="increase-cart-quantity"], [data-action="plus"]');
//           const minusBtn = wrapper.querySelector('[data-action="decrease-quantity"], [data-action="decrease-picker-quantity"], [data-action="decrease-cart-quantity"], [data-action="minus"]');

//           if (plusBtn) plusBtn.setAttribute('data-quantity', (isNaN(current) || current < moq) ? moq : current + 1);
//           if (minusBtn) minusBtn.setAttribute('data-quantity', (isNaN(current) || current <= moq) ? moq : current - 1); // If current is invalid or at MOQ, minus should try to go to MOQ, but the theme's 'min' should handle it.
//       };
//       input.addEventListener('change', () => { validateQty(); syncButtonAttrs(); });
//       input.addEventListener('blur', () => { validateQty(); syncButtonAttrs(); });

//       // keep buttons in sync immediately
//       syncButtonAttrs();

//       wrapper
//           .querySelectorAll('[data-action*="crease"], button[aria-label*="crease"]')
//           .forEach((btn) => {
//               btn.addEventListener('click', () => {
//                   // Remove setTimeout here to let our capture phase handlers lead.
//                   // Validation and sync will happen during input/change/blur, or immediately if we force it.
//                   // Let's force a re-validation and sync a tiny bit after to catch any theme-side changes.
//                   setTimeout(() => {
//                       validateQty();
//                       syncButtonAttrs();
//                   }, 50); // Small delay to allow theme's default handler to potentially finish processing.
//               });
//           });

//       // === Run once on load ===
//       validateQty();
//   });
// }

// === 2) Run once on first load ===
// document.addEventListener('DOMContentLoaded', () => initializeMOQNotes());

// === 3) Keep it alive in the CART DRAWER using a MutationObserver ===
// (function attachCartDrawerObserver() {
//   const drawer =
//     document.querySelector('[data-cart-drawer]') ||
//     document.querySelector('.cart-drawer') ||
//     document.querySelector('#CartDrawer') ||
//     document.body; // fallback

//   const observer = new MutationObserver((mutations) => {
//     for (const m of mutations) {
//       if (m.addedNodes && m.addedNodes.length) {
//         m.addedNodes.forEach((node) => {
//           // Only re-initialize if the added node actually contains a quantity input
//           if (node instanceof HTMLElement && node.querySelector('input[name*="quantity"]')) {
//             initializeMOQNotes(node);
//           }
//         });
//       }
//     }
//   });

//   observer.observe(drawer, { childList: true, subtree: true });
// })();

// === 4) Auto-open Warehouse 2.0 Mini Cart Drawer ===
document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('product:added', openMiniCart);
  document.addEventListener('cart:updated', (e) => {
    const cart = e?.detail?.cart;
    if (cart && cart.item_count > 0) openMiniCart();
  });

  function openMiniCart() {
    const miniCart = document.getElementById('mini-cart');
    if (miniCart) {
      miniCart.setAttribute('aria-hidden', 'false');
      miniCart.classList.add('is-open');
      document.dispatchEvent(
        new CustomEvent('theme:drawer:open', { detail: { drawerId: 'cart' } })
      );
    }
  }
});

// === 5) Inject CSS for MOQ warning (if not already in theme) ===
// (function injectMOQStyles() {
//   if (document.getElementById('moq-warning-styles')) return;
  
//   const style = document.createElement('style');
//   style.id = 'moq-warning-styles';
//   style.textContent = `
//     .quantity-warning {
//       display: none !important;
//       background: #fff3cd;
//       border: 1px solid #ffc107;
//       border-radius: 6px;
//       padding: 8px 12px;
//       margin-top: 8px;
//       font-size: 13px;
//       color: #856404;
//       animation: moq-shake 0.5s;
//       position: relative;
//       z-index: 10;
//       gap: 8px;
//       align-items: flex-start;
//     }

//     .quantity-warning.visible {
//       display: flex !important;
//     }

//     .quantity-warning.alert-shown {
//       animation: moq-pulse 0.5s ease;
//     }

//     .quantity-warning__icon {
//       font-size: 16px;
//       line-height: 1;
//       margin-top: 2px;
//     }

//     .quantity-warning__text {
//       flex: 1;
//       display: inline-block;
//     }

//     .quantity-warning strong {
//       font-weight: 600;
//     }

//     @keyframes moq-shake {
//       0%, 100% { transform: translateX(0); }
//       25% { transform: translateX(-5px); }
//       75% { transform: translateX(5px); }
//     }

//     @keyframes moq-pulse {
//       0%, 100% { transform: scale(1); }
//       50% { transform: scale(1.05); }
//     }

//     .moq-note {
//       font-size: 12px;
//       color: #666;
//       margin-top: 6px;
//       font-style: italic;
//     }

//     /* Mini cart specific styling */
//     .mini-cart .moq-slot--mini { display: block; width: 100%; }
//     .mini-cart .moq-slot--mini .moq-note { font-size: 11px; color: #666; font-style: italic; margin: 6px 0 4px 0; }
//     .mini-cart .quantity-warning.warning-mini {
//       background: #fff3cd;
//       border: 1px solid #ffc107;
//       border-radius: 4px;
//       margin-top: 4px;
//       padding: 6px 10px;
//       font-size: 12px;
//       color: #856404;
//       gap: 6px;
//       display: flex;
//       max-width: 100%;
//     }
//     .mini-cart .quantity-warning.warning-mini .quantity-warning__icon { font-size: 14px; }
//     .mini-cart .quantity-warning.warning-mini .quantity-warning__text { font-size: 12px; line-height: 1.3; }

//     /* Main cart page specific styling */
//     .template-cart .line-item__quantity {
//       display: flex;
//       align-items: flex-start;
//       gap: 16px;
//       flex-wrap: wrap;
//     }

//     .template-cart .line-item__quantity .quantity-selector {
//       flex-shrink: 0;
//     }

//     .template-cart .moq-slot--cart {
//       display: flex;
//       flex-direction: column;
//       align-items: flex-start;
//       gap: 6px;
//       min-width: 220px;
//       max-width: 280px;
//     }

//     .template-cart .moq-slot--cart .moq-note {
//       font-size: 13px;
//       font-style: normal;
//       font-weight: 600;
//       color: var(--color-accent, #0b63ce);
//       margin-top: 0;
//     }

//     .template-cart .quantity-warning.warning-cart {
//       background: #fff8e1;
//       border-color: #f0c36d;
//       box-shadow: 0 10px 24px rgba(0, 0, 0, 0.08);
//       margin-top: 0;
//       padding: 12px 14px;
//       color: #7a4e00;
//       white-space: normal;
//     }

//     .template-cart .quantity-warning.warning-cart .quantity-warning__icon {
//       font-size: 18px;
//       margin-top: 0;
//     }

//     .template-cart .quantity-warning.warning-cart .quantity-warning__text {
//       font-size: 13px;
//       line-height: 1.5;
//     }

//     .template-cart .line-item__quantity-remove {
//       order: 3;
//       width: 100%;
//       margin-top: 8px;
//     }

//     @media (max-width: 749px) {
//       .template-cart .line-item__quantity {
//         flex-direction: column;
//       }

//       .template-cart .moq-slot--cart {
//         min-width: 0;
//         max-width: 100%;
//       }
//     }
//   `;
//   document.head.appendChild(style);
// })();


// --- Mini Cart Instant Remove Button ---
document.addEventListener('click', function(e) {
  const removeBtn = e.target.closest('.js-mini-cart-remove');
  if (!removeBtn) return;

  e.preventDefault();
  const line = removeBtn.dataset.line;

  // Shopify AJAX call to remove the item
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line: parseInt(line), quantity: 0 })
  })
  .then(response => response.json())
  .then(cart => {
    // Reload mini cart section dynamically (Warehouse uses #mini-cart)
    fetch('/?sections=mini-cart')
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const updatedCart = doc.querySelector('#mini-cart');
        if (updatedCart) {
          document.querySelector('#mini-cart').innerHTML = updatedCart.innerHTML;
        } else {
          // fallback if ID differs
          location.reload();
        }
      });
  })
  .catch(err => console.error('Mini cart remove failed:', err));
});

// --- MINI CART REMOVE: keep drawer open + only remove one item ---
document.addEventListener('click', function(e) {
  const removeBtn = e.target.closest('.mini-cart__quantity-remove, .js-mini-cart-remove');
  if (!removeBtn) return;

  e.preventDefault();
  e.stopPropagation();

  const line = parseInt(removeBtn.dataset.line);
  if (!line) return;

  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line: line, quantity: 0 })
  })
  .then(res => res.json())
  .then(cart => {
    // Fade out and remove only the deleted item
    const itemEl = removeBtn.closest('.cart-item, .mini-cart-item, .cart-drawer__item');
    if (itemEl) {
      itemEl.style.transition = 'opacity 0.3s ease';
      itemEl.style.opacity = '0';
      setTimeout(() => itemEl.remove(), 300);
    }

    // Update subtotal only
    const subtotal = document.querySelector('.mini-cart__subtotal, .cart__subtotal, [data-cart-subtotal]');
    if (subtotal && Shopify && Shopify.formatMoney) {
      subtotal.textContent = Shopify.formatMoney(cart.total_price, Shopify.money_format);
    }

    // Keep drawer visible
    const drawer = document.querySelector('#mini-cart, .cart-drawer, .drawer');
    if (drawer) {
      drawer.classList.add('is-visible', 'active', 'open');
      document.body.classList.add('js-drawer-open');
    }
  })
  .catch(err => console.error('Mini cart AJAX remove failed:', err));
});

// --- Prevent Warehouse from closing drawer on cart updates ---
document.addEventListener('cart:updated', function(e) {
  const drawer = document.querySelector('.cart-drawer, #mini-cart, .drawer');
  if (drawer) {
    setTimeout(() => {
      drawer.classList.add('is-visible', 'active', 'open');
      document.body.classList.add('js-drawer-open');
    }, 200); // re-open immediately after theme tries to close
  }
});

